export default __webpack_public_path__ + "static/zsgir2021-011e1eb566246f6a914e0b83694b681f.png";